<template>
  <section class="task-wrap" :style="dBHeight">
    <modals-container @registCwExceptPaper="registCwExceptPaper"></modals-container>
    <div class="tab_ty1">
      <AuditTab :currentTab="3" />
      <div class="tab-content">
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="3" :currentTab2="3" />
            <div class="tab-content">
              <div>
                <div class="tb-list_ty1 audit003">
                  <div class="tb-header clear">
                    <div class="tb_num fl">
                      <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:totalCount})">
                      </div>
                    </div>
                      <div class="btnDiv fr">
                      <button
                        type="button"
                        class="btn-primary-small"
                        @click="cwPaperSetting()"
                      >
                        정보차단벽 예외 보드 등록
                      </button>
                    </div>
                      <div class="search_ty2" style="float: right;padding-right: 20px;">
                        <input
                          type="text"
                          required
                          placeholder="보드타이틀 또는 생성자 검색"
                          v-model="searchKey"
                          @keyup.enter="getSearchBoardList()"
                        />
                        <button
                          type="button"
                          class="input-txt"
                          @click="getSearchBoardList()"
                        >
                        {{$i18nUtil.trans("search.039","검색")}}
                        </button>
                      </div>
                  </div>

                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="cwpoList"
                    hide-default-footer
                    class="tb-contents"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <div>
                            <span class="ell-singleline d-block cursor-pointer">
                              {{ item.groupName }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="ell-singleline d-block cursor-pointer">
                              {{ item.categoryName }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="ell-singleline d-block cursor-pointer">
                              {{ item.paperTitle }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{$moment(item.regDate).format("YYYY.MM.DD")}}</span>                            
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.regUserName }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                          <button
                                type="button"
                                class="btn-primary-small"
                                @click="cofirmDelete(item)"
                                style="right: -100px"
                          >{{$i18nUtil.trans("button.delete","삭제")}}
                          </button>
                          </div>
                        </td>
                      </tr>
                      
                    </template>

                    <template slot="no-data">
                      <div class="nodata-txt-noicon">
                        <v-alert :value="true">
                          예외처리 된 보드가 없습니다.
                        </v-alert>
                      </div>
                    </template>
                  </v-data-table>

                  <div v-show="pageCount > 0" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import todoAddModal from "./modal/CwExceptSetting";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";

export default {
  components: {
    AuditSubTab,
    AuditTab,
    Dialog
  },
  data() {
    return {
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      enabled: true,
      show: false,
      page: 1,
      pageCount: 0,
      totalCount: 0,
      itemsPerPage: 10,
      singleSelect: false,
      selected: [],
      headers: [
        { text: "공간명", value: "groupName", sortable: false },
        { text: "카테고리명", value: "categoryName", sortable: false },
        { text: "보드타이틀", value: "paperTitle", sortable: false },
        { text: "예외설정일자", value: "regDate", sortable: false },
        { text: "생성자", value: "regUserName", sortable: false },
        { text: this.$i18nUtil.trans("button.delete","삭제"), value: "deleteCwpo", sortable: false },
      ],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      searchKey:"",
      isSearch:false,
      /* 페이지 변경 또는 정렬 이벤트시 */
      changeTableData: false,

      cwpoList: [],
      // searchUser: "",
      authorize: "",
    };
  },
  created() {
    this.getCwExceptList();
  },
  watch:{
    page:{
      handler() {
        if(this.changeTableData != true){
          this.changeTableData = true;
        }
        window.scrollTo(0, 0);
      }
    },
    changeTableData:{
      handler(){
        let obj = this;
        if(obj.changeTableData == true){
          setTimeout(() => {
            obj.changeTableData = false;
            // obj.boardListFilter = [];
            // obj.boardList = [];
            // this.showLoadingbar();
            // obj.getBoardAllList(this.isSearch);
            this.getCwExceptList();
          }, 500);
        }
      },
      deep: true
    },
  }, 
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast","showDialog"]),
    /* 코드 리스트 조회 */
    getCwExceptList() {
      let obj = this;

      let reqData = {};
      reqData.params = {
        currentPage: obj.page-1,
        searchKey: obj.searchKey,
        limitRow : obj.itemsPerPage
      };
      reqData.url = "/api/copaper/paper/getCwExceptPaperList";
      reqData.method = "post";
      
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
            obj.authorize = res.errorCode;
          } else { 
            obj.cwpoList = res.result.content;
            obj.totalCount = res.result.totalElements;
            obj.pageCount = res.result.totalPages; 
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    cwPaperSetting() {
      if(this.authorize != "NOT_AUTHORIZED"){
        const modalInfo = {
          name: "todoAddModal",
          obj: this.$modal,
          component: todoAddModal,
          width: "800px",
          userInfo: this.userInfo,
        };
        this.showModal(modalInfo);
      }
    },
    registCwExceptPaper(item){
      let obj = this;

      let reqData = {};
      reqData.params = {
        paperId : item.paperId
      };
      reqData.url = "/api/copaper/paper/registCwExceptPaper";
      reqData.method = "post";
      
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
            if(res.errorMessage == "ALREADY EXISTS"){
              obj.toastInfo.message = "이미 예외처리된 보드입니다.";
              obj.showToast(obj.toastInfo);
            } else{
              obj.authorize = res.errorCode;
            }
          } else {
            obj.toastInfo.message = "등록되었습니다.";
            obj.showToast(obj.toastInfo);
            this.getCwExceptList();
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    cofirmDelete(item){
      let obj = this;
      this.showConfirmDialog(
        { width: "420px" },
        "알림",
        "정보차단벽 예외처리된 보드를 삭제하시겠습니까?\n 정보차단정책에 해당되는 사용자가 존재하면 삭제할 수 없습니다.\n 멤버 제외 후 다시 시도해주세요.",
        "삭제",
        this.deleteCwPaper,
        item,
        "취소"
      );
    },
    deleteCwPaper(item){
      console.log(item);
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/paper/deleteCwPaper";
      reqData.method = "post";
      reqData.params = {
        paperId: item.modalParam.paperId,
      };
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            if(res.errorMessage == 'EXIST CW USER'){
              let blockUserNames = "";
              res.result.data.filter(function(res){
                blockUserNames += res.userName+", ";
              })
              const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title: "알림",
                button: "확인",
                contents: "차단멤버가 존재하여 삭제할 수 없습니다. \n 차단 멤버 : "+blockUserNames.substring(0,blockUserNames.length-2),
              };
              obj.showDialog(dialogInfo);
            }else{
              console.log(res);
            }
          } else {
            obj.toastInfo.message = "삭제 되었습니다.";
            obj.showToast(obj.toastInfo);              
            this.getCwExceptList();
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });     
    },
    getSearchBoardList(){
      this.isSearch = true;
      let obj = this;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },    
  },
};
</script>

<style scoped>
.audit003 {
  margin-top: 38px;
}
.audit003 >>> th:nth-child(1),
.audit003 >>> td:nth-child(1) {
  text-align: left;
  width: calc(100% - 260px - 260px - 130px - 130px - 50px) !important;  
}
.audit003 >>> th:nth-child(2),
.audit003 >>> td:nth-child(2) {
  text-align: left;
  width: 260px !important;
}
.audit003 >>> th:nth-child(3),
.audit003 >>> td:nth-child(3) {
  text-align: left;
  width: 260px !important;
}
.audit003 >>> th:nth-child(4),
.audit003 >>> td:nth-child(4) {
  text-align: center;
  width: 130px !important;
}
.audit003 >>> th:nth-child(5),
.audit003 >>> td:nth-child(5) {
  text-align: center;
  width: 130px !important;  
}
.audit003 >>> th:nth-child(6),
.audit003 >>> td:nth-child(6) {
  text-align: left;
  width: 100px !important;  
}
.audit003 >>> input {
  background-color: transparent;
}
.audit003 >>> th:nth-child(1) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(2) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(3) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(4) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(5) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(6) > span {
  margin-left: 40px;
}

.audit003 >>> td:nth-child(1) > div > span {
  text-align: left;
  margin-left: 30px;
  width: 260px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(2) > div > span {
  text-align: left;
  margin-left: 30px;
  width: 210px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(3) > div > span {
  text-align: left;
  margin-left: 30px;
  width: 210px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(4) > div > span {
  margin-left: 30px;
  width: 80px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(5) > div > span {
  margin-left: 30px;
  width: 80px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(6) > div > button {
  margin-left: 22px;  
}
.audit003 >>> tbody::after {
  background: none;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/CwExcept.vue